import React, { useState, useEffect } from "react";
import VirtualizedAutoComplete from "../../../../../../components/Dropdown/VirtualizedAutocomplete";

const ActionItemsModal = ({ isOpen, onClose, setActionItems, mechanics, defaultDate }) => {
  const [newActionItem, setNewActionItem] = useState({
    problemClass: "",
    problemSubClass: "",
    description: "",
    assignedTo: null,
    scheduleDate: defaultDate || new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16), // Adjust to local timezone
    isCompleted: false,
  });

  const [problemClasses, setProblemClasses] = useState(["Shut Down", "Breakdown", "Preventive Maintenance"]);
  const [problemSubClasses, setProblemSubClasses] = useState({
    "Shut Down": ["Door", "Motor", "Control Panel"],
    "Breakdown": ["Conveyor Belt", "Motor", "Control Panel"],
    "Preventive Maintenance": ["Wire", "Motor", "Control Panel"],
  });



  const handleAddActionItem = () => {
    if (!newActionItem.problemClass || !newActionItem.problemSubClass) {
      alert("Problem Class and Sub-Class are required!");
      return;
    }

    setActionItems((prev) => [...prev, { ...newActionItem, id: Date.now() }]);
    setNewActionItem({
      problemClass: "",
      problemSubClass: "",
      description: "",
      assignedTo: null,
      scheduleDate: defaultDate || new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16), // Adjust to local timezone
      isCompleted: false,
    });
  };

  return (
    <div className={`fixed inset-0 bg-black bg-opacity-30 mt-20 flex justify-center items-center ${isOpen ? "z-50" : "hidden"}`}>
      <div className="bg-white p-6 rounded-md shadow-lg w-2/5">
        <h2 className="text-xl font-bold mb-4">Add Action Item</h2>

        {/* Form for Adding Action Items */}
        <div className="flex flex-col gap-3">
          <label className="font-semibold">Problem Class</label>
          <select
            value={newActionItem.problemClass}
            onChange={(e) => setNewActionItem({ ...newActionItem, problemClass: e.target.value })}
            className="border p-2 rounded"
          >
            <option value="">Select Problem Class</option>
            {problemClasses.map((cls) => (
              <option key={cls} value={cls}>
                {cls}
              </option>
            ))}
          </select>

          <label className="font-semibold">Problem Sub-Class</label>
          <select
            value={newActionItem.problemSubClass}
            onChange={(e) => setNewActionItem({ ...newActionItem, problemSubClass: e.target.value })}
            className="border p-2 rounded"
            disabled={!newActionItem.problemClass}
          >
            <option value="">Select Sub-Class</option>
            {problemSubClasses[newActionItem?.problemClass]?.map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>

          <label className="font-semibold">Description</label>
          <textarea
            value={newActionItem.description}
            onChange={(e) => setNewActionItem({ ...newActionItem, description: e.target.value })}
            className="border p-2 rounded"
          />


          <label className="font-semibold">Schedule Date</label>
          <input
            type="datetime-local"
            value={newActionItem.scheduleDate}
            onChange={(e) => setNewActionItem({ ...newActionItem, scheduleDate: e.target.value })}
            className="border p-2 rounded"
          />

          <button onClick={handleAddActionItem} className="bg-green-500 text-white px-4 py-2 rounded mt-4">
            + Add Action Item
          </button>
        </div>

        <button onClick={onClose} className="bg-blue-500 text-white px-4 py-2 rounded mt-4 w-full">
          Close
        </button>
      </div>
    </div>
  );
};

export default ActionItemsModal;